import { render, staticRenderFns } from "./EmployerItemJobs.vue?vue&type=template&id=42537925&scoped=true"
import script from "./EmployerItemJobs.vue?vue&type=script&lang=js"
export * from "./EmployerItemJobs.vue?vue&type=script&lang=js"
import style0 from "./EmployerItemJobs.vue?vue&type=style&index=0&id=42537925&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42537925",
  null
  
)

export default component.exports